var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("SELF-INFLICTED INJURY")]),_c('h4',[_vm._v("Any injury or medical condition resulting from an intentional and deliberate act or omission of the member, or of any third person with consent or instructions from the member.")])])
}]

export { render, staticRenderFns }